import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.object

class ObjectEditor extends BaseEditor {
  constructor (options, defaults) {
    options = Object.assign(options, {
      collapsed: false
    })
    super(options, defaults)
  }

  build () {
    super.build()
    if (this.title && this.controls) {
      this.title.appendChild(this.controls)
    }
  }

  showAddProperty () {
    if (!this.addproperty_holder) return

    super.showAddProperty()

    this.addproperty_holder.style.left = ''
    this.addproperty_holder.style.right = '0px'
  }

  getWatchedFieldValues () {
    const mTitle = this.display_text?.[this.type] || this.getTitle()
    return { ...super.getWatchedFieldValues(), mTitle }
  }
}

export default ObjectEditor
